// ESM-Huelle um lib/scripts/pos/CLS_CSessionHandler.js (Phase 4, Welle 4b).
// Prototype-Stil bleibt vorerst.
function CSessionHandler() {
	this.openSessions = new Array();
	this.currentSession = 0;
	this.timeRecord = new CTimeRecord();
}

CSessionHandler.prototype.getSessionComponent = function () {
	return this.openSessions[this.currentSession];
}

CSessionHandler.prototype.addSession = function (UID) {
	var CSessionHandlerClass = this;
	this.currentSession = UID;
	 fs.writeFile("var/db/import/currentuser",UID);
	this.timeRecord.setComeTime(UID);

	this.openSessions[UID] = new CMainPOS(UID);
	this.openSessions[UID].properties.styles.zIndex = "2";
	this.openSessions[UID].UID = UID;
	$.when(this.openSessions[UID].draw()).done(function () {
		// Price Input preload
		CSessionHandlerClass.openSessions[UID].cmpPriceInput = CSessionHandlerClass.openSessions[UID].addChild(CPriceInputMode);
		CSessionHandlerClass.openSessions[UID].cmpPriceInput.draw();

		// Transaction Show preload
		CSessionHandlerClass.openSessions[UID].cmpBAR = CSessionHandlerClass.openSessions[UID].addChild(CTransactionShowMode);
		CSessionHandlerClass.openSessions[UID].cmpBAR.draw();
		CSessionHandlerClass.openSessions[UID].cmpBAR.makeOkButtons();
		CSessionHandlerClass.openSessions[UID].cmpBAR.makeNoteButtons();

		// Bon Disabled preload
		if (typeof CSessionHandlerClass.openSessions[UID].userProps["COL"] != "undefined" && CSessionHandlerClass.openSessions[UID].userProps["COL"] == -1) {
			CSessionHandlerClass.openSessions[UID].cmpPOSDisabled = CSessionHandlerClass.openSessions[UID].addChild(CPosDisabledMode);
			CSessionHandlerClass.openSessions[UID].cmpPOSDisabled.Main = CSessionHandlerClass.openSessions[UID];
		}

		CSessionHandlerClass.openSessions[UID].components.info.input.setFocus();

		POS.hourGlass.hide();
		POS.message.resetSession(UID);

		if (!POS.isPOSOpened) {
			if (typeof CSessionHandlerClass.openSessions[UID].userProps["COL"] != "undefined" && CSessionHandlerClass.openSessions[UID].userProps["COL"] == -1)
				CSessionHandlerClass.openSessions[UID].cmpPOSDisabled.draw();
		}

		CSessionHandlerClass.openSessions[UID].drawSubmenus();

		POS.rights.makeRights(CSessionHandlerClass.openSessions[UID]);

		CSessionHandlerClass.openSessions[UID].InfoIcons.highlightIcon("import", UID);

		CSessionHandlerClass.timeRecord.userId = UID;
		CSessionHandlerClass.timeRecord.checkIfPauseActive();
		
		if (POS.POSType=="Slave"){
			CSessionHandlerClass.openSessions[UID].components.leftPad.children[3].setEnabled(false, true);
			CSessionHandlerClass.openSessions[UID].components.leftPad.children[5].setEnabled(false, true);
		}
		
		//POS.DataImport.TimeoutCounter=0;
		
	});
}

CSessionHandler.prototype.hasOpenSession = function (UID) {
	for (var j in this.openSessions)
		if (j == UID)
			return true;

	return false;
}

CSessionHandler.prototype.anySession = function () {
	for (var j in this.openSessions)
		if (j == 0)
			continue;
		else
			return true;

	return false;
}

CSessionHandler.prototype.enableAllPOSSessions = function () {
	for (var j in this.openSessions) {
		if (j != 0) {
			var sess = this.openSessions[j];
			sess.components.leftPad.children[11].properties.caption.value = POS.lang.getText("BUTTONS", "END_BALANCE");
			sess.components.leftPad.children[11].properties.events.onMousedown = sess.endPOS;
			sess.components.leftPad.children[11].reDraw();
			sess.cmpOtherFunc.components.menuContainer.components.functionButtons.children[2].setEnabled(false);
			if (typeof sess.userProps["POC"] != "undefined" && sess.userProps["POC"] == 0)
				sess.components.leftPad.children[11].setEnabled(false);
			else
				sess.components.leftPad.children[11].setEnabled(true);

			if (typeof sess.userProps["COL"] != "undefined" && sess.userProps["COL"] == -1)
				sess.cmpPOSDisabled.restoreMainPos();
		}
	}
}

CSessionHandler.prototype.disableAllPOSSessions = function () {
	for (var j in this.openSessions) {
		if (j != 0) {
			var sess = this.openSessions[j];
			sess.components.leftPad.children[11].properties.caption.value = POS.lang.getText("BUTTONS", "START_BALANCE");
			sess.components.leftPad.children[11].properties.events.onMousedown = sess.startPOS;
			sess.components.leftPad.children[11].reDraw();
			if (typeof sess.userProps["POP"] != "undefined" && sess.userProps["POP"] == 0)
				sess.components.leftPad.children[11].setEnabled(false);
			else
				sess.components.leftPad.children[11].setEnabled(true);

			if (typeof sess.userProps["COL"] != "undefined" && sess.userProps["COL"] == -1) {
				sess.cmpPOSDisabled = sess.addChild(CPosDisabledMode);
				sess.cmpPOSDisabled.Main = sess;
				sess.cmpPOSDisabled.draw();
				sess.drawSubmenus();
			}

			if (typeof sess.userProps["SHD"] != "undefined" && sess.userProps["SHD"] == 0)
				sess.cmpOtherFunc.components.menuContainer.components.functionButtons.children[2].setEnabled(false);

		}
	}
}

CSessionHandler.prototype.goPause = function () {
	var me = POS.sessions;
	var userId = POS.sessions.currentSession;
	me.timeRecord.userId = userId;
	me.timeRecord.goPause(userId);
}

CSessionHandler.prototype.closeSessionFromId = function (UID, auto) {
	if (auto) {
		this.timeRecord.userId = UID;
		this.timeRecord.logoutAuto();
	}
	 fs.writeFile("var/db/import/currentuser","");
	POS.timeout.unregister("CDateTime" + UID);
	POS.timeout.unregister("CUpdateEMails" + UID);
	POS.timeout.unregister("CTestInput" + UID);

	this.openSessions[UID].removeMe();
	delete this.openSessions[UID];

	POS.message.killSession(UID);

	this.currentSession = 0;
	this.openSessions[0].initDisplay();

	if (auto)
		this.openSessions[0].components.container.components.user.field.input.setFocus();
}

CSessionHandler.prototype.loadSessionFromId = function (sessionId) {
	var SessionHandlerClass = this;
	this.currentSession = sessionId;
	this.currentMain = this.getSessionComponent();
	fs.writeFile("var/db/import/currentuser",sessionId);
	this.currentMain.majorShow();
	this.currentMain.components.infoIcons.properties.styles.visibility = "visible";
	this.currentMain.components.infoIcons.reStyle();

	var def4 = $.Deferred();

	if (typeof this.currentMain.userProps["COL"] != "undefined" && this.currentMain.userProps["COL"] == -1) {
		if ((typeof this.currentMain.cmpBalance != "undefined" && this.currentMain.cmpBalance.transmitted) ||
			(typeof this.currentMain.cmpCustomer != "undefined" && this.currentMain.cmpCustomer.transmitted))
			this.currentMain.disableInputFocus();
		else
			this.currentMain.enableInputFocus();

		this.currentMain.BonManager.initDisplay();
		var currentBon = this.currentMain.BonManager.currentBonId;
		$.when(this.currentMain.BonManager.isBonStillNew(currentBon)).then(function (val) {
			if (!val)
				SessionHandlerClass.currentMain.BonManager.reset();
			def4.resolve();
		});
	} else {
		def4 = 0;
	}
	$.when(def4).then(function () {
		POS.hourGlass.hide();

		Trans.UID = sessionId;

		if (POS.message.sessions[sessionId].active)
			POS.message.recoverLast(sessionId);
		
		//POS.DataImport.TimeoutCounter=0;
	});
}

CSessionHandler.prototype.hideCurrentSession = function () {
	if (this.currentSession == 0)
		return;

	this.openSessions[this.currentSession].components.infoIcons.properties.styles.
	visibility = "hidden";
	this.openSessions[this.currentSession].components.infoIcons.reStyle();

	this.openSessions[this.currentSession].majorHide();
	this.openSessions[this.currentSession].disableInputFocus();
	this.currentSession = 0;

	this.openSessions[0].components.container.components.user.field.input.setFocus();
}

CSessionHandler.prototype.isLastWithClosePOSRights = function (requesterUID) {
	/*privMan.enablePrivilege (privList);*/

	var notLast = false;

	for (var j in this.openSessions) {
		if (j != requesterUID && j != 0) {
			if (this.openSessions[j].userProps["POC"] != "undefined" && this.openSessions[j].userProps["POC"] == -1)
				return false;
		}
	}

	return true;
}

CSessionHandler.prototype.loadSessionFromBarcode = function (loginId) {
	/*privMan.enablePrivilege (privList);*/
	var SessionHandlerClass = this;
	var sql = "SELECT U_ID FROM U WHERE Login = '" + loginId + "'";
	$.when(POS.SQLiteCon.execute(sql)).then(function (rows) {
		if (rows.length == 0) {
			//r.free();
			// Ohne Funkscanner (entfallen 26.8.2026) war !barcodeRequested
			// immer wahr, die Meldung erschien also stets.
			var text = POS.lang.getText("MESSAGES", "UNKNOWN_ID_CARD");
			POS.message.show(text, "warning", "OK");

			return;
		}

		var newUID = rows[0].U_ID;
		//r.free();

		if (SessionHandlerClass.currentSession == newUID) {
			var sess = SessionHandlerClass.getSessionComponent();
			// Recht "SCA" fehlt: Sitzungswechsel per Karte wird abgebrochen.
			// Der Abbruch BLEIBT - loadSessionFromBarcode laeuft auch beim
			// Handscanner am Kassenplatz. Entfallen ist nur die Meldung, die
			// ohnehin nur das Funkgeraet erreichte (26.8.2026); an der Kassa
			// war der Abbruch schon vorher stumm.
			if (typeof sess.userProps["SCA"] != "undefined" && sess.userProps["SCA"] == 0)
				return;

			if (POS.message.sessions[newUID].active)
				POS.message.recoverLast(newUID);

			return;
		}

		SessionHandlerClass.timeRecord.setComeTime(newUID);

		var oldUserName = null;

		if (SessionHandlerClass.currentSession != 0) {
			oldUserName = SessionHandlerClass.openSessions[SessionHandlerClass.currentSession].userProps.Name;

			SessionHandlerClass.hideCurrentSession();
		}

		if (SessionHandlerClass.hasOpenSession(newUID)) {
			var sess = SessionHandlerClass.openSessions[newUID];
			// Recht "SCA" fehlt: Sitzungswechsel per Karte wird abgebrochen.
			// Der Abbruch BLEIBT - loadSessionFromBarcode laeuft auch beim
			// Handscanner am Kassenplatz. Entfallen ist nur die Meldung, die
			// ohnehin nur das Funkgeraet erreichte (26.8.2026); an der Kassa
			// war der Abbruch schon vorher stumm.
			if (typeof sess.userProps["SCA"] != "undefined" && sess.userProps["SCA"] == 0)
				return;

			SessionHandlerClass.loadSessionFromId(newUID);

			var newUserName = SessionHandlerClass.openSessions[SessionHandlerClass.currentSession].userProps.Name;

			if (oldUserName && newUserName != oldUserName) {
				var text = POS.lang.getText("MESSAGES", "USER_CHANGED");
				text += "<br><br>" + SessionHandlerClass.openSessions[SessionHandlerClass.currentSession].userProps.Name;
				POS.message.ignoreSave = true;
				POS.message.holdMessage = true;
				POS.message.show(text, "info", "OK", newUID, SessionHandlerClass.recoverLastMessage);
			}
		} else {
			SessionHandlerClass.openSessions[0].initDisplay();
			SessionHandlerClass.openSessions[0].components.container.components.user.field.input.properties.attributes.value = loginId;
			SessionHandlerClass.openSessions[0].components.container.components.user.field.input.reAttribute();
			SessionHandlerClass.openSessions[0].components.container.components.pin.field.input.setFocus();
		}
	});
}

CSessionHandler.prototype.recoverLastMessage = function (userId) {
	window.setTimeout(POS.message.recoverLast, 10, userId);
}

export { CSessionHandler };
